module.exports = __webpack_public_path__ + "img/icon-play--orange.81be6328.svg";